import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl, SafeScript, SafeStyle, SafeUrl } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(protected _sanitizer: DomSanitizer) { }

  public transform(value: string, type: "url" | "html" | "style" | "script" | "resourceUrl" = "url"): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {
    if (!value) {
      return undefined;
    }
    switch (type) {
      case 'url': return this._sanitizer.bypassSecurityTrustUrl(value);
      case 'html': return this._sanitizer.bypassSecurityTrustHtml(value);
      case 'style': return this._sanitizer.bypassSecurityTrustStyle(value);
      case 'script': return this._sanitizer.bypassSecurityTrustScript(value);
      case 'resourceUrl':
      default:
        return this._sanitizer.bypassSecurityTrustResourceUrl(value);
    }
  }
}
